export const ANSWER_SETTER = "ANSWER_SETTER";
export const ANSWER_RESETTER = "ANSWER_RESETTER";
export const ANSWER_FULL_SETTER = "ANSWER_FULL_SETTER";
